module.exports = __webpack_public_path__ + "static/scale-model-of-tampa-florida-51e35480d077227f8bb343fb81197a2e.png";